import React from 'react';
import actions from '../../actions';
import {connect} from 'react-redux';

import './style.css';

class MainView extends React.Component {
  constructor(props) {
    super(props);

    this.doLogout = this.doLogout.bind(this);
  }

  doLogout(e) {
    e.preventDefault();
    this.props.didLogout();
  }

  render() {
    return (
      <div className="app-container">
        <div className={`top-bar ${this.props.hide_navigation ? 'hide-navigation' : ''}`}>
          <div className="top-bar-left">
            <ul className="menu">
              <li className="menu-text"> SMS 1.0</li>
              <li><a href="/">Home</a></li>
              <li><a href="#/batches">Batch</a></li>
              <li><a href="#/leads">Leads</a></li>
              <li><a href="#/chats">Chat</a></li>
              <li><a href="#/statistics">Statistics</a></li>
            </ul>
          </div>
          <div className="top-bar-right">
            <ul className="menu">
              <li><a href="#logout" onClick={ this.doLogout }>Logout</a></li>
            </ul>
          </div>
        </div>
        <div className="grid-container">
          <div className="grid-x grid-padding-x">
            <div className="cell small-12 main-view-container">
              { this.props.children }
            </div>
          </div>
        </div>
      </div>);
  }
}

const mapDispatchToProps = (dispatch) => ({
  didLogout: () => dispatch(actions.user.didLogout()),
});

export default connect(null, mapDispatchToProps)(MainView)


// WEBPACK FOOTER //
// ./src/components/MainView/index.js